import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {ResponseTask, Task, TasksQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_TASK_URL = `${API_URL}/api/task-template`
const GET_TASKATTACHEMENT_URL = `${API_URL}/api/task-template/anexo`

export const getTaskTemplateById = (id: ID): Promise<Task> => {
  return axios.get(`${GET_TASK_URL}/${id}`).then((response: AxiosResponse<Task>) => response.data)
}

export const getTaskTemplatesList = (query: string): Promise<TasksQueryResponse> => {
  return axios
    .get(`${GET_TASK_URL}?${query}`)
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

export const updateOrderTaskTemplate = (
  tasks: {id: number; order_mytasks: number}[]
): Promise<TasksQueryResponse> => {
  return axios
    .put(`${GET_TASK_URL}/updateordercell`, {tasks: tasks})
    .then((d: AxiosResponse<TasksQueryResponse>) => d.data)
}

export const createTaskTemplate = (task: Task): Promise<ResponseTask | undefined> => {
  const formData = new FormData()

  formData.append('name', task.name ?? '')
  formData.append('description', task.description ?? '')
  formData.append('priority', task.priority ?? '')

  task?.checklist_name?.map((checklist) => {
    formData.append('checklist_name[]', checklist)
  })

  task?.checklist_concluded?.map((checklist) => {
    formData.append('checklist_concluded[]', checklist)
  })

  task?.file?.map((file) => {
    formData.append('documents[]', file)
  })

  formData.append('tags', JSON.stringify(task.tags))

  formData.append('users', JSON.stringify(task.users))

  formData.append('sequence_responsibles', JSON.stringify(task.sequence_responsibles))

  return axios
    .post(`${GET_TASK_URL}/novo`, formData)
    .then((response: AxiosResponse<ResponseTask>) => response.data)
}

export const updateTaskTemplate = (task: Task): Promise<ResponseTask> => {
  task.sequence_responsibles = task.sequence_responsibles.reduce(
    (acc: any, user: any, index: any) => {
      acc[Number(user.user_id ?? user.id)] = {order: index}
      return acc
    },
    {} as {[key: number]: {order: number}}
  )

  return axios
    .put(`${GET_TASK_URL}/${task.id}/editar`, task)
    .then((response: AxiosResponse<Response<ResponseTask>>) => response.data)
    .then((response: Response<ResponseTask>) => response.data)
}

export const deleteTaskTemplate = (taskId: ID): Promise<void> => {
  return axios.delete(`${GET_TASK_URL}/${taskId}/excluir`).then((response) => response.data)
}

export const createAttachement = ({
  template_id,
  file,
}: {
  template_id: ID
  file: string
}): Promise<void> => {
  const formData = new FormData()

  formData.append('file', file ?? '')

  return axios
    .post(`${GET_TASK_URL}/${template_id}/anexo`, formData)
    .then((response) => response.data)
}

export const deleteAttachment = (id: ID): Promise<void> => {
  return axios.delete(`${GET_TASKATTACHEMENT_URL}/${id}`).then((response) => response.data)
}

export const taskTemplateResponsibleAdjust = ({task_template_id, user_id}: any): Promise<any> => {
  return axios
    .post(`${GET_TASK_URL}/${task_template_id}/users/${user_id}/adjust`)
    .then((response: AxiosResponse<any>) => response.data)
}

export const addSubtaskTemplate = (
  taskTemplateId: ID,
  subtaskTemplateId: ID
): Promise<any> => {
  return axios
    .post(`${GET_TASK_URL}/${taskTemplateId}/subtasks`, {
      subtask_template_id: subtaskTemplateId,
    })
    .then((response: AxiosResponse<any>) => response.data)
}

export const removeSubtaskTemplate = (
  taskTemplateId: ID,
  subtaskTemplateId: ID
): Promise<any> => {
  return axios
    .delete(`${GET_TASK_URL}/${taskTemplateId}/subtasks/${subtaskTemplateId}`)
    .then((response: AxiosResponse<any>) => response.data)
}

type AssignableSubtaskTemplate = {
  id: number
  name: string
  priority?: string | null
}

type GetAssignableSubtaskTemplatesParams = {
  search?: string
  limit?: number
  excludeTemplateId?: ID
}

export const getAssignableSubtaskTemplates = async ({
  search = '',
  limit = 20,
  excludeTemplateId,
}: GetAssignableSubtaskTemplatesParams): Promise<Array<AssignableSubtaskTemplate>> => {
  try {
    const response = await axios.get(`${GET_TASK_URL}/assignable-subtasks`, {
      params: {
        search,
        limit,
        exclude_template_id: excludeTemplateId,
      },
    })

    return response?.data?.data ?? []
  } catch {
    return []
  }
}
